import BillingCycle from  '../Rate/BillingCycleEnum'

export function createDefaultTenantRate(overrides = {}) {
  return {
    tenantDTO: {
      id: 0,
    },
    billingCycle: BillingCycle.MONTHLY,
    agreedRate: 0,
    agreedDate: new Date().toISOString().split("T")[0],
    active: true,
    tenantRate:0,
    ...overrides,
  };
}
